enum OvertimePayPeriodType {
  CALIFORNIA = 'California',
  FOLLOW_COMPANY = 'Follow Company',
  STANDARD = 'Standard',
  CUSTOM = 'Custom',
}

export default OvertimePayPeriodType;
